import Styles from './BlazeLogo.module.scss'
import { BlazeLogo as BlazeLogoIcon } from 'components/MultiStepFlow/MultiStepPageLayout/BlazeLogo'
import cx from 'classnames'

export const BlazeLogo = ({ center = false }: { center?: boolean }) => {
  return (
    <div className={cx(Styles.logo, { [Styles.center]: center })}>
      <BlazeLogoIcon width={108} height={30} />
    </div>
  )
}
